import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {MatButtonModule} from '@angular/material/button';
import { AppRoutingModule ,routingComponents} from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTooltipModule } from '@angular/material/tooltip';
import {ToastrModule} from 'ngx-toastr'
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatToolbarModule} from '@angular/material/toolbar';;
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTableModule } from '@angular/material/table';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {ReactiveFormsModule} from '@angular/forms';
import { MaterialModule } from './core/material.module';
import { HeaderComponent } from './header/header.component';
import { HttpClientModule,HTTP_INTERCEPTORS } from '@angular/common/http';
import { FooterComponent } from './footer/footer.component';
import {MatDialogModule} from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import {ScrollingModule} from '@angular/cdk/scrolling';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import { SelectFeatureComponent } from './select-feature/select-feature.component';
import { MatCardModule} from '@angular/material/card';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule} from '@angular/material/paginator';
import { StopWatchComponent } from './stop-watch/stop-watch.component';
import { ContainerComponent } from './container/container.component';
import { LoginComponent } from './login/login.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { MdePopoverModule } from '@material-extended/mde';
import { AuthGuard } from './auth/auth.guard';
import {TokenInterceptorService} from './auth/token-interceptor.service';
import { from } from 'rxjs';
import { NewJobService } from './app-service/newJob.service';
import { QrCodeReaderComponent } from './qr-code-reader/qr-code-reader.component';
import { NgQrScannerModule } from 'angular2-qrscanner';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { MatExpansionModule } from '@angular/material/expansion';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthService } from './app-service/auth.service';
import { ConfirmPasswordDialogComponent } from './confirm-password-dialog/confirm-password-dialog.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule} from '@angular/material/core';
@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    routingComponents,
    SelectFeatureComponent,
    StopWatchComponent,
    ContainerComponent,
    LoginComponent,
    QrCodeReaderComponent,
    ConfirmPasswordDialogComponent
  ],
  entryComponents:[ConfirmPasswordDialogComponent],
  imports: [
    BrowserModule,HttpClientModule,MatTooltipModule,MatExpansionModule,MatBadgeModule,
    MatSelectModule,MatCardModule,MdePopoverModule,
    MatButtonToggleModule,MatCheckboxModule,NgQrScannerModule,ZXingScannerModule,
    MatSidenavModule,MatSortModule,
    MatDialogModule,
    AppRoutingModule,
    BrowserAnimationsModule,ToastrModule.forRoot({}),
    FlexLayoutModule,ScrollingModule,
    MatInputModule,MatListModule,
    MatFormFieldModule,
    FormsModule,MatPaginatorModule,MatDatepickerModule,MatNativeDateModule,
    ReactiveFormsModule,MatIconModule,
    MaterialModule,MatToolbarModule,
    MatButtonModule,MatTableModule, ServiceWorkerModule.register('ngsw-worker.js', {
  enabled: environment.production,
  // Register the ServiceWorker as soon as the app is stable
  // or after 30 seconds (whichever comes first).
  registrationStrategy: 'registerWhenSable:30000'
}), ServiceWorkerModule.register('ngsw-worker.js', {
  enabled: environment.production,
  // Register the ServiceWorker as soon as the app is stable
  // or after 30 seconds (whichever comes first).
  registrationStrategy: 'registerWhenStable:30000'
})
  ],
  exports: [MatIconModule,MatDatepickerModule],
  providers: [AuthGuard,NewJobService,BnNgIdleService,AuthService,
  {
    provide:HTTP_INTERCEPTORS,
    useClass:TokenInterceptorService,
    multi:true
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
